<app-modal-generico [modelo]="modalGenerico">
    <div class="table-responsive">
      <app-tablas page="1" [sizeData]="dataTabla.paging.totalItems"  [headers]="headers" (paginado)="onPaginado($event)">
        <tr *ngFor="let item of items; let i=index" class="small">
            <td>{{item.descripcion}}</td>
            <td>{{item.fecha_creacion}}</td>
            <td>{{item.usuario_creacion}}</td>
            <td>{{item.motivo}}</td>
        </tr>
      </app-tablas>
    </div>
  </app-modal-generico>
  